import React from 'react';
import { AlertCircle, Loader } from 'lucide-react';
import { Modal } from './Modal';

const variantStyles = {
  danger: {
    button: 'bg-red-600 hover:bg-red-700',
    icon: 'from-red-500 to-red-600',
    gradient: 'from-red-50 to-orange-50'
  },
  warning: {
    button: 'bg-yellow-600 hover:bg-yellow-700',
    icon: 'from-yellow-500 to-yellow-600',
    gradient: 'from-yellow-50 to-orange-50'
  }
};

export const ConfirmDialog = ({
  open,
  onConfirm,
  onCancel,
  title = 'Confirm Action',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger',
  loading = false
}) => {
  const styles = variantStyles[variant] || variantStyles.danger;

  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      icon={AlertCircle}
      maxWidth="max-w-md"
      headerGradient={styles.gradient}
    >
      <div className="p-6">
        {message && <p className="text-gray-700 mb-6">{message}</p>}

        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors font-medium"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={`px-4 py-2 text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center transition-colors font-medium ${styles.button}`}
          >
            {loading ? (
              <>
                <Loader className="animate-spin mr-2" size={16} />
                Processing...
              </>
            ) : (
              confirmLabel
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};
